<script setup lang="ts">
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'
  defineProps<{ label: string; onClick?: () => void }>()
</script>

<template>
  <div class="section-header flex-container">
    <span class="alignment"> {{ label }}</span>
    <UiButton v-if="onClick" @click="onClick" variant="negative" icon="cross" size="small" />
  </div>
</template>

<style scoped>
  .section-header {
    margin: 1rem 0 0.25rem 0;
    color: var(--colours-grey-1);
    padding: 0.25rem 0.5rem;
    background: var(--colours-grey-3);
    font-size: 1.4rem;
    font-weight: 500;
    font-family:
      Jost,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica Neue,
      Arial,
      sans-serif;
  }

  .alignment {
    align-content: center;
  }

  .section-header i {
    color: red;
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
  }
</style>
